
export default {
  "m": {
    "sms_login": "Đăng nhập tin nhắn ngắn",
    "get_vercode": "Gởi đi",
    "change_mobile": "Thay đổi số điện thoại",
    "log_reg_agree": "Đăng nhập / Đăng ký có nghĩa là đồng ý với {msg_ss}",
    "old_mobile": "Số điện thoại ban đầu",
    "new_mobile": "Số điện thoại mới",
    "agency_reginfo_fill": "Điền thông tin đăng ký bang hội",
    "audit_res": "Kết quả kiểm toán",
    "agency_name": "Tên Team",
    "agency_name_input": "Vui lòng nhập tên bang hội",
    "agency_name_input_note": "Lưu ý: Tên bang hội nên ngắn gọn và dễ nhớ, không quá 30 từ",
    "agency_logo": "LOGO Agency",
    "agency_logo_unpload_note": "Vui lòng tải lên LOGO guild rõ ràng ở định dạng PNG/JPG/JPEG",
    "agency_contact_name": "Tên Agency",
    "user_contact_name": "Vui lòng điền tên của người tiếp xúc hàng ngày với nền tảng người dùng",
    "agency_contact_phone": "Số điện thoại",
    "agency_whatsapp": "Số WhatsApp(hoặc số zalo) của agc",
    "agency_whatsapp_contact": "Vui lòng nhập thông tin liên hệ WhatsApp của lãnh đạo guild",
    "agency_use_lang": "Ngôn ngữ team dùng",
    "agency_head_ID": "ID Agency của app BuzzCast",
    "agency_ID_input": "Vui lòng nhập ID người dùng của người đứng đầu bang hội BuzzCast APP để phân phối quỹ sau này",
    "reg_country": "Quốc gia đăng ký",
    "inhand_ID_photo": "Ảnh Cầm CMND",
    "upload_note_t": "Tải lên các cân nhắc",
    "agency_self_inhand_ID": "Nó phải do chính đại lý mang theo giấy tờ hộ chiếu",
    "photo_must_clearly": "Mặt trước phải thể hiện rõ người và thông tin hộ chiếu thật bằng hình chụp",
    "mian_form_country": "IDOL từ nước nào",
    "invite_code": "Mã mời",
    "your_profile_submit_success": "Tài liệu của bạn đã được gửi thành công! chúng tôi sẽ đối phó với nó càng sớm càng tốt.<br>Kết quả kiểm tra sẽ được gửi đến thông báo BuzzCast APP của người đứng đầu bang hội và vui lòng chú ý kiểm tra!",
    "your_profile_approved": "Tài liệu bạn gửi chưa được xét duyệt! Lý do từ chối là ảnh hộ chiếu mang theo không rõ ràng \".<br>Vui lòng điền lại hoặc liên hệ với trợ lý chính thức trên BuzzCastAPP để được tư vấn.",
    "return_refill": "Quay lại để điền lại",
    "success_agency": "Chúc mừng bạn đã cài đặt thành công nền tảng, [nhấp vào tôi] để bắt đầu hoạt động!",
    "personal_account": "Tài khoản cá nhân",
    "my_agency": "Hội của tôi",
    "your_agency_been_forcibly": "Bang hội của bạn đã bị nền tảng cưỡng chế chấm dứt hoạt động và bạn sẽ không thể đăng nhập vào hệ thống được nữa.<br>Nếu bạn có bất kỳ câu hỏi nào, vui lòng liên hệ với trợ lý chính thức của BuzzCastAPP hoặc bộ phận vận hành độc quyền.",
    "invite_live_join": "Mời chủ nhà tham gia liên kết bang hội",
    "base_info": "Thông tin cơ bản",
    "apply_time": "Ngày nộp hồ sơ",
    "join_time": "Tham gia thời gian",
    "cooper_status": "Tình trạng hợp tác",
    "streamer_manage": "Quản lý máy chủ lưu trữ",
    "sereamer_apply": "Phê duyệt Máy chủ lưu trữ",
    "sereamer_nickname": "Biệt danh chủ nhà",
    "remark": "Nhận xét",
    "no_remark": "Không có lưu ý gì",
    "add_remark": "Thêm nhận xét",
    "birth": "Ngày sinh",
    "user_status": "Trạng thái người dùng",
    "temporarily_frozen": "Đóng băng tạm thời",
    "permanently_frozen": "Đóng băng vĩnh viễn",
    "fans_num": "Số lượng người theo dõi",
    "sign_status": "Tình trạng hợp đồng",
    "sign_ing": "Theo hợp đồng",
    "sign_time": "Thời hạn hợp đồng",
    "release_time": "Ngày hủy",
    "live_viola_record": "Hồ sơ vi phạm phát sóng trực tiếp",
    "sign_record": "Bản ghi nhớ hợp đồng",
    "current_contract_status": "Tình trạng hợp đồng hiện tại",
    "termination_reason": "Lý do chấm dứt",
    "violation_reason": "Lý do vi phạm",
    "violation_time": "Ngày vi phạm",
    "processing_result": "Kết quả xử lý",
    "exported_data": "Xuất dữ liệu",
    "join_agency_apply": "Chấp thuận gia nhập guild",
    "audit_status": "Trạng thái được chấp thuận",
    "pending_review": "Đang chờ xem xét",
    "pending_HQ_review": "Đang chờ đánh giá trụ sở chính",
    "not_approved_HQ": "Đánh giá trụ sở không thành công",
    "withdrawn": "Đã thu hồi",
    "audit_trail": "Hồ sơ kiểm toán",
    "oper": "Vận hành",
    "other_video_materials": "Các tài liệu video khác",
    "pass": "Thông qua",
    "pass_streamer_join_agency_apply": "Áp dụng đơn đăng ký thành viên neo",
    "reject_streamer_join_agency_apply": "Đơn đăng ký thành viên neo bị từ chối",
    "agree_streamer_join_agency": "Đồng ý với neo {msg_ss1} để trở thành người gửi dưới {msg_ss2} ~",
    "reject_streamer_join_agency": "Đơn đăng ký trở thành thành viên của {msg_ss2} của thành viên {msg_ss2} đã bị từ chối!",
    "img_material": "Tài liệu hình ảnh",
    "approver": "Người phê duyệt",
    'user_enter_bind_phone': 'Hãy nhập số điện thoại',
    'vericode': 'Mã nghiệm chứng',
    'input_vericode': 'Xin hãy nhập mã xác minh',
    'login': 'Đăng nhập',
    'reg': 'Đăng lý',
    'logout': 'Thoát',
    'search_for': 'Tìm kiếm',
    'subscription_closed': 'Hợp đồng bị hủy bỏ',
    'agency_ID': 'Mã bang hội: {msg_ss}',
    'reset': 'Reset/ thiếp lập lại',
    'live_ID': 'ID của streamer',
    'live_record': 'Ghi màn hình phát sóng trực tiếp',
    'email': 'Email',
    'phone': 'Số điện thoại di động',
    'mastery_lang': 'Ngôn ngữ chính',
    'to': 'Đến',
    'cancel': 'Hủy',
    'Confirm': 'Xác định',
    'preview': 'Xem trước',
    'rejected': 'Đã từ chối',
    'tip': 'Nhắc nhở',
    'i_got_it': 'Tôi hiểu rồi',
    'cancelled': 'Đã hủy',
    'refused': 'Từ chối',
    'agency_agree': 'Guild đã đồng ý',
    'platform_agree': 'Nền tảng đã đồng ý',
    'user_not_exist': 'Người dùng không tồn tại',
    'user_frozen': 'Tài khoản đã được khóa',
    'reviewing': 'Trong đánh giá',
    'review_pass': 'Đánh giá thông qua',
    'review_failed': 'Kiểm tra thất bại',
    'xx_hours': '{msg_ss} giờ',
    'xx_days': '{msg_ss} ngày',
    'xx_hour': '{msg_ss} giờ',
    'xx_day': '{ms  g_ss} ngày',
    'xx_year': '{msg_ss} năm',
    'xx_years': '{msg_ss} năm',
    'check_phone_istrue': 'Vui lòng kiểm tra số điện thoại xem có được nhập chính xác không',
    'male': 'Nam',
    'female': 'Nữ',
    'avatar': 'Chân dung',
    'normal': 'Bình thường',
    'live_room': 'Phòng trực',
    'view': 'Tra cứu',
    'oper_success': 'Thao tác thành công',
    'copy_success': 'Sao chép thành công',
    'new_mobile_already_reg': 'Một số điện thoại di động mới đã được đăng ký',
    'general_user': 'Người dùng chung',


    'copy': 'Sao chép',
    'gender': 'Giới tính',
    'submit': 'Đệ trình',
    'permanent': 'Vĩnh viễn',
    'agree_agreement': 'Đồng ý và tuân theo hợp đồng',
    'vericode_error': 'Mã xác minh là sai',
    'resend': 'Gởi lại',
    'approved': 'Thông qua',
    'not_approved': 'Không vượt qua được',
    'agency_rejected': 'Nền tảng bị từ chối',
    'select': 'Lựa chọn',
    'search': 'Tìm kiếm',
    'rejection_reason': 'Lý do từ chối',
    'no_data': 'Dữ liệu không tồn tại',
    'oper_failed': 'Lỗi hệ thống',
    'leave_agency_apply': 'Phê duyệt rút bỏ bang hội',
    'over_word_limit': 'Limite numero di parole superato',
    'delete': 'Xóa',
    'nickname': 'Biệt danh',
    'file_is_too_large': 'Tập tin quá lớn',

    'community_convention': 'Hội nghị cộng đồng Buzzcast',
    'approval_time': 'Thời gian phê duyệt',
    'guild_system_title': 'Hẹ thống công hội nền tảng xã giao BuzzCast',
    'return': 'Trở về',
    'img_upload_fail': 'Ảnh tải lên chưa thành công',
    'cooper_ing': 'Đang hợp tác',
    'upload_file_format_incorrect': 'Tệp đã tải lên không đúng định dạng',
    'token_invalid': 'Token không hợp lệ, vui lòng đăng nhập lại!',
    'network_busy': 'Mạng đang bận, vui lòng thử lại',
    'minute': '{msg_ss}minuto',

    'live_room_ID': 'ID phòng live',
    'scan_code': 'Quét mã truy cập APP BuzzCast',
    'open_code': 'Mở APP BuzzCast, click vào mã QR của tôi để quét',
    'refresh': 'Làm mới',
    'login_confirm': 'Xác nhận truy cập',
    'account': 'Thông tin số tài khoản',
    'user_name': 'Tên người dùng',
    'edit': 'Sửa chữa',
    'changing': 'Thay đổi liên kết',
    'mobile_number': 'Số tài khoản máy di động',
    'mobile_login': 'Có thể sử dụng số di động {msg_ss} để truy cập',
    'appId_login': 'Có thể sử dụng AppID cho tài khoản [{msg_ss}] quét lại truy cập',
    'code_login': 'Chưa liên kết BuzzCastAppID, sau khi liên kết có thể sử dụng quét mã QR truy cập',
    'verification_log': 'Chưa liên kết số di động, sau khi liên kết có thể sử dụng số di động và mã OTP để truy cập',
    'binding_success': 'Liên kết thành công',
    'binding_mobile': 'Liên kết số di động',
    'edit_name': 'Sửa tên người dùng',
    'binding_alert': 'Nhắc nhở thay đổi liên kết',
    'new_appId': 'Trực tiếp sử dụng mã quét liên kết APPID mới, APPID gốc sẽ bị trực tiếp thay thế',
    'binding_account': 'Liên kết số tài khoản BuzzCastApp',
    'anchor_earings': 'Lợi ích của streamer',
    'signing_date': 'Ngày ký kết hợp động',
    'statistical_date': 'Ngày thống kê',
    'valid_min': 'Tổng thời gian có hiệu lực (phúc)',
    'valid_day': 'Ngày có hiệu lực (Số ngày)',
    'total_revenue': 'Tổng lời ích',

    'bind': 'Đặt',
    'please_agree_agree': 'Vui lòng đồng ý với hợp đồng',
    'note': 'Lưu ý: Thời gian được hiển thị bởi hệ thống này là giờ New York (EST)',
    'app_phone': 'Đăng ký số điện thoại di động của APP',
    'host_num': 'Số lượng IDOLS',
    'enter_host_num': 'Vui lòng nhập số của tất cả các máy chủ',
    'platform': 'Thừ app nào qua',
    'statement': 'Doanh thu hàng tháng app trước',
    'enter_income': 'Vui lòng nhập thu nhập trung bình hàng tháng',
    'check_commas': 'Định dạng không chính xác. Vui lòng kiểm tra xem nhiều nền tảng có được phân tách bằng dấu phẩy không',
    'submit_success': 'Tài liệu của bạn đã được gửi thành công! chúng tôi sẽ đối phó với nó càng sớm càng tốt',
    'usd': 'Đô la Mỹ',
    'many_platforms': 'Vui lòng nhập nền tảng phát sóng trực tiếp mà bạn đã hợp tác trước đó, tối đa 20 nền tảng',
    'limit_platform': 'Lên đến 20 nền tảng',
    'user_has_delete': 'Người dùng đã bị hủy',
    'cant_commit': 'Bạn đã là một phát thanh viên theo hợp đồng và bạn không thể đăng ký bang hội để giải quyết cùng một lúc',
    'cant_commit_1': 'Bạn đã đăng ký một đài truyền hình đã ký hợp đồng và bạn không thể đăng ký bang hội để giải quyết cùng một lúc',
    'passwd': 'Mật khẩu',
    'passwd_placeholder': 'Mật khẩu hỗ trợ từ 6 đến 20 đơn vị',
    'live_rights': 'Đánh giá miễn phí thời gian',
    'edit_log': 'Thay đổi bản ghi',
    'edit_time': 'Thay đổi thời gian',
    'edit_pwd': 'Đổi mật khẩu',
    'old_pwd': 'Mật khẩu cũ',
    'new_pwd': 'Mật khẩu mới',
    'confirm_pwd': 'Xác nhận mật khẩu',
    'forget_pwd': 'Quên mật khẩu?',
    'email_check': 'Cách thức hộp thư không chính xác',
    'phone_pwd_error': 'Số điện thoại hoặc mật khẩu bị sai',
    'ten_min_error': 'Vui lòng thử lại sau 10 phút',
    'phone_bind_error': 'Số điện thoại di động đã bị ràng buộc với các tài khoản khác, vui lòng thay thế số điện thoại di động mới để liên kết.',
    'bc_user_id_tip': 'Buzzcast APP ID',
    'bc_user_id_error': 'ID hội trưởng đã được điền vào, vui lòng điền lại',
    'pwd_error': 'Mật khẩu bị lỗi',
    'phone_not_reg_error': 'Tài khoản không được đăng ký',
    'pwd_nq': 'Hai lần nhập mật khẩu mới không giống nhau',
    'sign_anchor_error': 'Bạn đã là một phát thanh viên theo hợp đồng và bạn không thể đăng ký bang hội để giải quyết cùng một lúc',
    'apply_anchor_error': 'Bạn đã đăng ký một đài truyền hình đã ký hợp đồng và bạn không thể đăng ký bang hội để giải quyết cùng một lúc',
    'have-expired': 'Xin nhập lý do từ chối',
    'approval-time': 'Thời gian phê duyệt',
    'reasons-for-refusal': 'Xin nhập lý do từ chối',
    'Transfer-grounds': 'Lý do chuyển khoản',
    'code_expire': 'Captcha hết hạn, hãy nhấn vào captcha để làm mới lại',
    'transfer-approval': 'Phê duyệt chuyển nhượng',
    'live_state_placeholder': 'Trạng thái phát sóng',
    'live_state_open': 'Bình thường',
    'live_state_temporary_banned': 'Cấm phát sóng',
    'live_state_forever_banned': 'Vĩnh viễn cấm phát sóng',
    'live_allowed_time': 'Cho phép thời gian phát sóng',
    'live_banned_time': 'Chu kỳ cấm',
    'deduct_money': 'Khấu trừ số tiền B',
    'final_income': 'Lợi ích thực tế',
    'select_start_dt': 'Vui lòng chọn thời gian bắt đầu',
    'select_end_dt': 'Vui lòng chọn thời gian kết thúc',
    'less_then_end_dt': 'Thời gian bắt đầu phải nhỏ hơn hoặc bằng thời gian kết thúc',
    'System_automatically_through': 'Hệ thống tự động thông qua',
    'btrade_err': 'ID guild này không khả dụng',

    'mouth_anchor': 'IDOL lương hàng tháng',
    'day_anchor': 'IDOL lương hàng ngày',
    'guild_anchor': 'Phần thưởng agc(lương hàng ngày)',
    'mouth_anchor_st': 'Thời gian lương hàng tháng bắt đầu ',
    'mouth_anchor_et': 'Thời gian lương hàng tháng kết thúc',
    'day_anchor_st': 'Thời gian lương hàng ngày bắt đầu ',
    'day_anchor_et': 'Thời gian lương hàng ngày kết thúc',
    'all_award_bcoin': 'Tổng thu nhập thưởng lương hàng ngày',
    'live_hour': 'Phần thưởng thời lượng live có hiệu lực',
    'salary_day': 'Thời gian',
    'day_in_come': 'Thu nhập của agency trong ngày (xu-B)',
    'award_ration_flag_str': 'Tỷ lệ thưởng',
    'payable_money': 'Phần thưởng xu-B của agency',
    'host_bcoins': 'Doanh thu Xu-B idol ',
    'total_official': 'Tổng số Xu-B thưởng của chính thức',
    'actual_bcoins_awarded': 'Số thưởng Xu-B thực tế',
    "change_bound_account":"Thay đổi tài khoản kết nối" ,
    "agent_id_form":"ID agency:" ,
    "BuzzCast_verification_code":"Mã xác minh BuzzCast:" ,
    "send_success":"gởi thành công" ,
    "account_changed_successfully":"Tài khoản kết nối thay đổi thành công." ,
    "invite_guild_url":"Link lời mời trở thành của agency BuzzCast: {msg_ss}" ,
    "invite_guild_code":"Mã mời của tôi: {msg_ss}" ,
    "save":"lưu" ,
    "compile":"Chỉnh sửa" ,
    "agent_nvitation_eward":"Phần thưởng được mời agency" ,
    "agent_name":"Biệt danh của Agc" ,
    "guild_id":"Mã Agc" ,
    "guild_income_30days":"Thu nhập của bang hội trong 30 ngày qua" ,
    "guild_invite_income_30days":"Thu nhập từ việc mời agc trong 30 ngày qua" ,
    "agency_commission_ratio":"Tỷ lệ hoa hồng Agency" ,
    "invite_income_bcoins":"Phần thưởng mời B coin" ,
    "id_not_exist": "ID này không tồn tại",
    'reward_distribution_status': 'Trạng thái phân phối phần thưởng',
    'must_number': 'Đầu vào của bạn phải ở định dạng số thuần túy.',

  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/vi.js